'use client';
'use strict';

var classes = {"field":"m-45c4369d"};

module.exports = classes;
//# sourceMappingURL=PillsInput.module.css.cjs.map
